( function( $ ) {
  /********
   * Insert Mega Menu if the top-level menu item has children.
   ********/
  
  /* Set up the container of the content */
  $('.desktop-menu-wrapper .dp-plain-menu > .menu-item.menu-item-has-children').each(function() {
    var curr_node = $(this);
    var link_name = $('> a', this)[0].innerText.toLowerCase().split(" & ").join('_').replace("’", "");
    var img_name = link_name.split(' ').join('_');
    var json_name = img_name + '.json';
    
    var sub_menu = $('> ul', this);
    var mega_menu = $('<div class="mega-menu"></div>');

    mega_menu.append(sub_menu);
    mega_menu.append('<div class="mega-menu__description"></div>');
    mega_menu.append('<div class="mega-menu__image"></div>');
    curr_node.append(mega_menu); 
  });

  /* Get the content on hover of the menu item */
  $( '.menu-item > a' ).mouseenter( function() {
    /* Get the menu id */
    var menu_id = $( this ).data( 'menu_id' );

    /* Get the content */
    var menu_description = $( '[data-menu_content="' + menu_id + '"] .__description' ).html();
    var menu_image = $( '[data-menu_content="' + menu_id + '"] .__image' ).html();

    /* Target the parent li to place the menu content based on their parent menu */
    var menu_parent = $( this ).closest( '.menu-item-has-children' );

    /* Place the content */
    $( '.mega-menu__description', menu_parent ).html( menu_description );
    $( '.mega-menu__image', menu_parent ).html( menu_image );
  } );
} ) ( jQuery );